module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vhead11-b92fd28822929d746f1b2a7057ae7748.jpg";